/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { SolutionRequestDto_Input } from '../models/SolutionRequestDto_Input';
import type { SolutionRunResponseDto } from '../models/SolutionRunResponseDto';

export class DiscoveryEvaluationSolutionRequestsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Run Solution Request
   * Run the engine over a fully-specified request.
   *
   * Callers get back exactly three things: the ranked solution space, the
   * input set the engine actually consumed (post-inference — see
   * `echo_resolved_inputs`), and provenance naming what produced the run
   * (engine, source mode, inventory snapshot).
   *
   * Two sources, two failure vocabularies. A `pinned` run is answerable
   * offline, so its only failures are about the dataset. A `live` run
   * reaches two environments the caller can point elsewhere — the monolith
   * and the discovery database — so its failures are split between "your
   * request is wrong" (4xx) and "this environment can't answer it, change
   * config and retry" (503).
   *
   * ``require_operator_role`` gates the whole route, both sources included:
   * one tier per route, not per mode, so a `pinned` call — which itself
   * never reaches the monolith — needs an operator bearer too. That is
   * also what makes the `live` source safe: by the time this body runs,
   * ``get_logged_in_user()`` is guaranteed non-``None``, so
   * ``MonolithApiClient.get_monolith_api()`` forwards the caller's own
   * token rather than dying on a missing one with an opaque 401.
   * @param requestBody
   * @returns SolutionRunResponseDto Successful Response
   * @throws ApiError
   */
  public runSolutionRequestInternalDiscoveryEvaluationSolutionRequestsPost(
    requestBody: SolutionRequestDto_Input
  ): CancelablePromise<SolutionRunResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/discovery/evaluation/solution-requests',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
